// [목적] report 도메인 REST API 클라이언트 — POST /reports 매핑
// [이유] FlowLine A7(054b57db 일부): 폴리오/댓글 신고 버튼이 소비할 단일 진입점.
//        packages/types/report.ts 의 zod 스키마로 요청 검증 + 응답 parse(BE/FE 계약 단일 소스).
// [사이드 이팩트] JwtAuthGuard + CsrfGuard 필수(apps/api reports.controller.ts) — 게스트는
//                호출 전 useAuthGate('report.create') 로 가로채야 함(호출부 책임).
// [수정 시 고려사항] 에러 코드(report.TARGET_NOT_FOUND 404 / report.SELF_REPORT_FORBIDDEN 400 /
//                   report.ALREADY_REPORTED 409)는 apps/api core/exception/codes.ts 가 정본 —
//                   문구 변경 시 ReportDialog.tsx 의 매핑도 동기 갱신 필요.

import {
  createReportSchema,
  reportSchema,
  type CreateReportInput,
  type Report,
} from '@gangwoncanvas/types';

import { fetchWithEnvelope } from './http.js';

/**
 * [목적] POST /reports — 신고 생성
 * [이유] ReportDialog 제출 핸들러에서 호출
 * [사이드 이팩트] reports 테이블 1행 INSERT(BE). 성공 시 201 + Report 반환
 * [수정 시 고려사항] input 은 호출 전 이미 폼에서 구성됨 — 여기서 재검증(parse)하여 FE 실수도 방어
 */
export async function createReport(input: CreateReportInput): Promise<Report> {
  const validated = createReportSchema.parse(input);
  const data = await fetchWithEnvelope<unknown>('/reports', {
    method: 'POST',
    body: JSON.stringify(validated),
  });
  return reportSchema.parse(data);
}
